export default {
  features: {
    index: {
      seo: {
        title: 'جميع الميزات',
        description:
          'أدوات مدعومة بالذكاء الاصطناعي لإدارة التوصيل: تتبع العلامة التجارية وتحسين المسارات ووكلاء الذكاء الاصطناعي وإثبات التسليم والتخصيص التلقائي والتحليلات والمزيد.',
      },
      badge: 'ميزات المنصة',
      title: 'جميع الميزات',
      subtitle:
        'أدوات مدعومة بالذكاء الاصطناعي للتوصيل والتوجيه وإثبات التسليم وعمليات الأسطول. استكشف كل ميزة أدناه.',
      stats: {
        features: 'الميزات',
        aiPowered: 'مدعوم بالذكاء الاصطناعي',
        dispatchRouting: 'الإرسال والتوجيه',
        uptime: 'وقت تشغيل المنصة',
      },
      learnMore: 'اعرف المزيد',
      cta: {
        title: 'هل أنت مستعد لتجربة Geofleet؟',
        subtitle: 'ابدأ الآن أو احجز عرضاً لترى هذه الميزات في العمل.',
      },
    },
  },
};
